<template>
  <bench-dialog
    v-model="visible"
    append-to-body
    width="430px"
  >
    <div class="overSizeDialog">
      <div class="oversize-content">
        上传失败！素材空间已达到上限，马上开通会员畅享更大的素材空间。
      </div>
      <div
        v-if="isPoor"
        class="oversize-btn"
        @click="$router.push('/vipsolo')"
      >
        升级个人VIP&nbsp;&nbsp;
        <span>(500G)</span>
      </div>
      <div
        class="oversize-btn"
        @click="$router.push('/vip')"
      >
        升级企业VIP&nbsp;&nbsp;
        <span>(无限制)</span>
      </div>
    </div>
  </bench-dialog>
</template>
<script>
import benchDialog from '@/components/global/benchDialog';
export default {
  name: 'OverSizeDialog',
  components: {
    benchDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isPoor: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let visible;
    return {
      visible
    };
  },
  watch: {
    value: function(val) {
      this.visible = val;
    },
    visible: function(val) {
      this.$emit('input', val);
    }
  }
};
</script>
<style lang="scss" scoped>
.overSizeDialog {
  padding: 20px 40px;
  .oversize-content {
    padding-bottom: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #666;
  }
  .oversize-btn {
    margin-top: 18px;
    width: 310px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #5a62b3;
    border-radius: 13px;
    cursor: pointer;
    &:hover {
      background: #40489c;
    }
    span {
      font-weight: bold;
    }
  }
}
</style>
